module.exports = __webpack_public_path__ + "static/media/atlanta.289ac453.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cities/atlanta.jpg
// module id = 516
// module chunks = 0